import { render, staticRenderFns } from "./list-detect.vue?vue&type=template&id=5e479e9e&"
import script from "./list-detect.vue?vue&type=script&lang=js&"
export * from "./list-detect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports